import React,{useState,useEffect,useRef} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import moment from 'moment'
import {BsSearch} from 'react-icons/bs'
import { empwiseattApi } from '../../../utils/AdminDashApi/EmpWiseAttApi'
import '../../../sassFiles/sassPages/admindashboard/campwiseatten.scss'
import '../../../sassFiles/sassPages/admindashboard/adminCommon.scss'
import { campwiseattApi } from '../../../utils/AdminDashApi/CampWiseAttApi'
import { empAttreportApi } from '../../../utils/AdminDashApi/EmpAttReportApi'
import { BsPlus } from 'react-icons/bs'
import { optionsCampus, optionsClass, optionsShift, optionsdayofmonth, optionsdayofweek, optionsdept, optionsdesignation, optionsexptype, optionssection, purplebutton40, purplebuttonw10040 } from '../../Helper'
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'
import { admitCardApi } from '../../../utils/AdminDashApi/AdmitCardApi'
import axios from 'axios';
import MobileInputSubComp from './sub_components/MobileInputSubComp'
const AdmitCardCompmb = () => {
    const [activefrom,setactivefrom] = useState("")
  const [activeto,setactiveTo] = useState("")
  
  const [activefrommdlnm,setactivefrommdlnm] = useState("")
  const [activetomdl,setactiveTomdl] = useState("")
  const [activetomdlnm,setactiveTomdlnm] = useState("")
 

  const [department,setdepartment] = useState("")
  const [labeldepartment,setlabeldepartment] = useState("")
  const [borderdepartment,setborderdepartment] = useState("")
  const [campus,setcampus]= useState("")
  const [bordercampus,setbordercampus]= useState("")
  const [labelcampus,setlabelcampus]= useState("")
  const [type,settype]= useState("")
  const [bordertype,setbordertype]= useState("")
  const [labeltype,setlabeltype]= useState("")




  const [shifttypemain,setshifttypemain] = useState("")
  const [bordershifttypemain,setbordershifttypemain] = useState("")
  const [labelshifttypemain,setlabelshifttypemain] = useState("")



  const [enddatemain,setenddatemain] = useState("")
  const [borderenddatemain,setborderenddatemain] = useState("")
  const [labelenddatemain,setlabelenddatemain] = useState("")

  const [classmain,setclassmain] = useState("")
  const [borderclassmain,setborderclassmain] = useState("")
  const [labelclassmain,setlabelclassmain] = useState("")
  
  const [sectionmain,setsectionmain] = useState("")
  const [bordersectionmain,setbordersectionmain] = useState("")
  const [labelsectionmain,setlabelsectionmain] = useState("")
  
  const [employeeIDmain,setemployeeIDmain] = useState("")
  const [borderemployeeIDmain,setborderemployeeIDmain] = useState("")
  const [labelemployeeIDmain,setlabelemployeeIDmain] = useState("")
  
  const [studentIDmain,setstudentIDmain] = useState("")
  const [borderstudentIDmain,setborderstudentIDmain] = useState("")
  const [labelstudentIDmain,setlabelstudentIDmain] = useState("")
  


  const drpfuncsectionmain=(myval,myid)=>{
    setsectionmain(myval)
  }
  const drpfuncclassmain=(myval,myid)=>{
    setclassmain(myval)
  }
  const drpfuncshifttypemain=(myval,myid)=>{
    setshifttypemain(myval)
  }
 
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",
}
  const [classresponse, setclassresponse] = useState([]);
  //classdropdownload
  useEffect(() => {
    const fetchClassDropdown = async () => {
        try {
            const classresponse = await axios.get(
                "https://sass.britishstandardschool.com/api/Public/ClassList",
                {},
                headers
            );
            setclassresponse(classresponse.data);
            console.log(classresponse);
        } catch (err) {
            if (err.classresponse) {
                console.error(err.classresponse.data);
                console.log(err.classresponse.status);
                console.log(err.classresponse.header);
            } else {
                console.error(`Error: ${err.message}`);
            }
        }
    };
    fetchClassDropdown();
}, []);

const initialState = admitCardApi.data.map(item => ({
  ...item
}));
  const [ischkmodal, setischkmodal] = useState([initialState]);
  const [ischkmodalall, setischkmodalall] = useState([]);


  

  const updateTickmark = (empid, newValue) => {
    console.log(ischkmodal[0])

  
    // setischkmodal(prevData => ({
    //   ...prevData,
    //   [empid]: {
    //     ...prevData[empid],
    //     tickmark: newValue
    //   }
    // }));
    var myarr = ischkmodal[0]

    for(var i=0;i<myarr.length;i++){
      if(empid == myarr[i].empid){
        
        myarr[i].tickmark = true
        setischkmodal(myarr)
      }

    }
    
    
   
  };
const handleChangechk = (event,myid) => {
    var checkedme = ""
    if (event.target.checked) {
      console.log('✅ Checkbox is checked');
      updateTickmark(myid, true);
    } else {
      console.log('⛔️ Checkbox is NOT checked');
      updateTickmark(myid, false);
    }
    
   
  };







const handleChangechkall = (event,myid) => {
    if (event.target.checked) {
      console.log('✅ Checkbox is checked');
    } else {
      console.log('⛔️ Checkbox is NOT checked');
    }
    setischkmodalall(current => !current);
  };


const handleSearch=()=>{
    console.log("searched")
}


  const handleShowEdit=(e,item)=>{
    setShow3(true)

    
  }

  const bottomSave=()=>{

    
    const finalarr = {
        tickmart: ischkmodal.length>1?ischkmodal:ischkmodal[0],
  }
    console.log(finalarr)
  }

 
 
  const [roleDrp,setRoledrp] = useState("")
 
 
  const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [statusvalueerr,setstatusvalueerr] = useState("")
  const [activefromMoment,setactivefromMoment] = useState("")


  
  
      const handleActiveTo = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTomdl(dtfinalc)

            
        }
        
        
    }
   
 

    const [show3, setShow3] = useState(false);
    
  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(admitCardApi.data)



  const mainfilter=(arr)=>{
      setfilteredArr(arr);    
  }

  const drpfunctiondepartment=(myval,myid)=>{
    setdepartment(myval)
  }
  const drpfunctioncampus=(myval,myid)=>{
    setcampus(myval)
  }
  const drpfunctiontype=(myval,myid)=>{
    settype(myval)
  }



  const [tempfilteredarr,settempfilteredarr] = useState([])

  let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
  

  useEffect(() => {
    const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
    const tempArr = filteredArr.slice(itemOffsetfiltered, endOffsetfiltered);
    settempfilteredarr(tempArr);
    setPageCountfiltered(Math.ceil(filteredArr.length / itemsPerPagefiltered));
    
    //flag2
  }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr]);

      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % admitCardApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
    
      
    
   
    const [formdata,setfromdata]=useState({
      usersearch:""
    })
    

    // populatedata
    const [name,setname] = useState("")
    const [id,setid] = useState("")

    
   

   
    
    
    const optionsparentmenu = [
      {
        id:1,
        opt:"Home1"
      },
      {
        id:2,
        opt:"Home2"
      },
    ]
    const [parentmenudrp,setparentmenudrp] = useState("")
    const drpfuncparentmenu=(parentmenydrpval,myid)=>{
      setparentmenudrp(parentmenydrpval)
    }
    
  

  
   
  
  const handleInput = (e)=>{
    setfromdata({...formdata,[e.target.name]:e.target.value})
  }


  const handlePrint=()=>{

  }

  //start
  return (
    <>
    <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
            <div className="mobilecontainer">
                <div className="adminmbheading">
                    <h3>Admit Card</h3>
                </div>
                <div className="admbwrap pb0">
                    <Row>
                            <MobileInputSubComp col="12" direct="center" name="Class">
                                <div className="dropdownwrapper">
                                    <Dropdown2 err={borderclassmain} func={drpfuncclassmain} myplaceholder={classmain}fontsize="12" fontfamily="'Poppins', sans-serif" options={classresponse} />
                                </div>
                                <label>{labelclassmain}</label>
                            </MobileInputSubComp>
                            <MobileInputSubComp col="6" direct="left" name="Section">
                            <div className="dropdownwrapper">
                                    <Dropdown2 err={bordersectionmain} func={drpfuncsectionmain} myplaceholder={sectionmain}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssection} />
                                </div>
                                <label>{labelsectionmain}</label>
                            </MobileInputSubComp>
                            <MobileInputSubComp col="6" direct="right" name="Student ID">
                            <input style={borderstudentIDmain ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={studentIDmain} onChange={(e) => setstudentIDmain(e.target.value)} />
                            <label>{labelstudentIDmain}</label>
                            </MobileInputSubComp>
                            <Col xs={10} className="m-auto  mt-2">
                                <Row>

                            <Col xs={6} className="pr5">
                                <div className="basicinput d-flex justify-content-end">
                                    
                                    <button className='cmbutton' onClick={handlemainpagesearch}> Search</button>
                                </div>
                                
                                </Col>
                                <Col xs={6}  className="pl5">
                                    <div className="basicinput">

                                
                                    <button className='cmbutton' onClick={handlePrint}>Print</button>
                                    </div>
                                </Col>
                                </Row>
                            </Col>
                   
                    </Row>
                </div>
                <div className="admbwrap pr0">
                    <div className="tablewrapscroll">
                    <div className="flexvaluetable hrshiftsetuptablediv">
                    <table>
                      <thead>
                        <tr>
                        <th>
                                <input
                                      type="checkbox"
                                      value={ischkmodalall}
                                      onChange={(e)=>handleChangechkall()}
                                      id="modalchk"
                                      name="modalchk"                        
                                  />
                                  </th>
                                
                            {
                              admitCardApi.heading.map((item,key)=>{
                                    
                                return(
                                    <>
                                  <th key={key}> <div>{item.head}</div> </th>
                                    
                                    </>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            tempfilteredarr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                    
                                  <td>
                                  <input
                                      type="checkbox"
                                      value={ischkmodal}
                                      onChange={(e)=>handleChangechk(e,item.empid)}
                                      id="modalchk"
                                      name="modalchk"                        
                                  />
                                  </td>
                                  <td>{item.name}</td>
                                  <td>{item.studentID}</td>
                                  <td>{item.class}</td>
                                  <td>{item.section}</td>
                                  <td>{item.roomno}</td>
                                  <td>{item.floorno}</td>
                                
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                    </div>
                </div>
                <div className="admbwrap">
                <Row>
                <Col lg={12} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={2}
                      pageCount={pageCountfiltered}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffset+1} to {itemOffset+10} of {admitCardApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default AdmitCardCompmb